<template>
  <div
    class="jade-list-item-main-content"
    role="contentinfo"
  >
    <div class="jade-list-item-main-content__label">
      <jade-text
        :weight="computedLabelWeight"
        :variant="computedLabelSize"
        :color="computedLabelColor"
      >
        {{ label }}
      </jade-text>

      <jade-tooltip
        v-if="tooltip"
        :text="tooltip"
        placement="top-start"
      >
        <jade-icon
          use="circle-info"
          size="small"
        />
      </jade-tooltip>
    </div>

    <jade-text
      v-if="value && !isSimple"
      variant="text-medium"
      weight="semibold"
      color="high"
    >
      {{ value }}
    </jade-text>

    <template v-if="isSimple">
      <jade-text
        v-if="description"
        variant="text-small"
        weight="regular"
        color="medium"
        data-testid="description"
      >
        {{ description }}
      </jade-text>
      <jade-text
        v-if="thirdLine"
        variant="text-small"
        weight="regular"
        color="medium"
        data-testid="thirdLine"
      >
        {{ thirdLine }}
      </jade-text>
    </template>
  </div>
</template>

<script>
import JadeText from '../../JadeText/index.vue'
import JadeIcon from '../../JadeIcon/index.vue'
import JadeTooltip from '../../JadeTooltip/index.vue'

import SIZE_ENUM from '../../enums/sizes.enum'
import VARIANT_ENUM from '../../enums/variant.enum'
import COLOR_ENUM from '../../enums/colors.enum'
import WEIGHT_ENUM from '../../enums/weight.enum'

export default {
  name: 'JadeListItemContent',

  components: {
    JadeText,
    JadeIcon,
    JadeTooltip
  },

  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'simple',
      validation: v => ['display', 'simple'].includes(v)
    },
    value: String,
    tooltip: String,
    description: String,
    thirdLine: String,
    variant: String
  },

  computed: {
    isSimple () {
      return this.type === 'simple'
    },
    computedLabelSize () {
      return this.isSimple
        ? `text-${SIZE_ENUM.MEDIUM}`
        : `text-${SIZE_ENUM.SMALL}`
    },
    computedLabelWeight () {
      return this.isSimple ? WEIGHT_ENUM.MEDIUM : WEIGHT_ENUM.REGULAR
    },
    computedLabelColor () {
      if (this.variant === VARIANT_ENUM.ACTIVE) return COLOR_ENUM.BRAND
      if (this.variant === VARIANT_ENUM.DANGER) return COLOR_ENUM.NEGATIVE

      if (this.isSimple) return COLOR_ENUM.HIGH

      return COLOR_ENUM.MEDIUM // type === 'display'
    }
  }
}
</script>
